import { useFormatUtils } from '../../../hooks/useFormatUtils';

interface StatsBreakdownProps {
    title: string;
    data: Record<string, number>;
}

export default function StatsBreakdown({ title, data }: StatsBreakdownProps) {
    const { capitalizeFirst } = useFormatUtils();

    return (
        <div className="bg-white rounded-lg shadow p-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <div className="space-y-3">
                {Object.entries(data).map(([key, count]) => (
                    <div key={key} className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">
                            {capitalizeFirst(key)}
                        </span>
                        <span className="text-sm font-medium text-gray-900">{count}</span>
                    </div>
                ))}
            </div>
        </div>
    );
} 